<nav class="navbar navbar-expand-md navbar-light bg-light ">
  <a class="navbar-brand" href="#">
    <img src="assets/btv_logo.svg" height="75" class="d-inline-block align-top" alt="">
    <span class="navbar-text mt-2">{{title}}</span>
  </a>
  <div class="collapse navbar-collapse ml-5" id="navbarsExampleDefault">
    <ul class="navbar-nav mr-auto" *ngIf="isLoggedIn">
      <li class="nav-item" routerLinkActive="active">
        <a class="nav-link" [routerLink]="['/courses']">Lehrgänge</a>
      </li>
      <li class="nav-item" routerLinkActive="active">
        <a class="nav-link" [routerLink]="['/courses']" (click)="newCourseSelection()">neuer Lehrgang</a>
      </li>
      <!-- <li class="nav-item" routerLinkActive="active">
        <a class="nav-link" [routerLink]="['/competitions']">Wettkämpfe</a>
      </li>
      <li class="nav-item" routerLinkActive="active">
        <a class="nav-link" [routerLink]="['/competitions/edit/0', {type:'competition', form:4}]">neuer Wettkampf</a>
      </li> -->
      <li class="nav-item" *ngIf="isAdmin">
        <a class="nav-link" [routerLink]="['/courses']" (click)="openModalWithComponent()">Export</a>
      </li>
    </ul>
    <div class="nav-item" *ngIf="debug">
      <pre>
      Role: {{assignedRoles}}
      isAdmin {{isAdmin}}
      isLoggedIn: {{isLoggedIn}}
      </pre>
    </div>
    <ul class="navbar-nav navbar-right" *ngIf="isLoggedIn">
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/users/currentUser']">
          <fa-icon [icon]="faUser" size="2x"></fa-icon>
          {{currentUser?.name}}&nbsp;&nbsp;&nbsp;
        </a>
      </li>
      <li class="nav-item">
        <button class="btn btn-outline-danger" (click)="logout()">
          <fa-icon [icon]="faSignOut"></fa-icon> Logout
        </button>
      </li>
    </ul>
    <ul class="navbar-nav navbar-right ml-auto" *ngIf="!isLoggedIn">
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['login']">
          <button class="btn btn-outline-success">
            <fa-icon [icon]="faSignIn"></fa-icon> Login
          </button>
        </a>
      </li>
    </ul>
  </div>
</nav>
